import {Table, TBody, Td, Th, Thead, Tr} from '@/components';
import type {Metrics} from '@/screens/Processor/Metrics/types';

export interface PITableProps {
  metrics: Metrics;
}
export const ratesHeaderHue = 'bg-blue-50 p-8 shadow-sm sticky';
const PaymentInstrumentRateTable = ({metrics}: PITableProps) => {
  return (
    <Table className="w-full">
      <Thead>
        <Tr enableHover={false}>
          <Th className="px-2">Payment Instrument</Th>
          <Th className="px-2">Success Rate (%)</Th>
        </Tr>
      </Thead>
      <TBody>
        {Object.keys(metrics.paymentInstrumentSuccessRates)
          .sort(
            (a, b) =>
              metrics.paymentInstrumentSuccessRates[a] -
              metrics.paymentInstrumentSuccessRates[b],
          )
          .map((paymentInstrument, index) => (
            <PITRow
              key={paymentInstrument}
              index={index}
              metrics={metrics}
              paymentInstrument={paymentInstrument}
            />
          ))}
      </TBody>
    </Table>
  );
};

const PITRow = ({
  metrics,
  paymentInstrument,
  index,
}: {
  metrics: Metrics;
  paymentInstrument: string;
  index: number;
}) => {
  const zebraRow = index % 2 === 0 ? '' : 'bg-gray-50 dark:bg-dark-zebraRow';

  return (
    <Tr className={zebraRow}>
      <Td className={`px-2 font-medium`}>{paymentInstrument}</Td>
      <Td className={`px-2 font-medium`}>
        {metrics.paymentInstrumentSuccessRates[paymentInstrument].toFixed(2)}
      </Td>
    </Tr>
  );
};

export default PaymentInstrumentRateTable;
